import type { DashboardMetric } from "../type";
import { SegmentsGroupMonthlyVisitsGraphWidget } from "./SegmentsGroupMonthlyVisitsGraphWidget";

export class SegmentsVisitDurationGroupGraphWidget extends SegmentsGroupMonthlyVisitsGraphWidget {
    protected metric: DashboardMetric;
    protected dataSource;

    constructor() {
        super();
        this.dataSource = "Duration";
        this.metric = "SegmentsVisitDurationGroup";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsVisitDurationGroupGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsVisitDurationGroupGraphWidget.register();
